import React, { useEffect, useRef, useState } from 'react';
import Layout from '../../wrappers/layout';
import { Card, Tab, Tabs, Button, Form, InputGroup } from 'react-bootstrap';
import CurrencyInput from 'react-currency-input-field';

import './styles.css';
import { Formik, Field, Form as FormikForm, ErrorMessage } from 'formik';
import { useLocation } from 'react-router-dom';
import moment from 'moment';
import { userStore } from 'store/UserStore';
import { formatAmount, makeQuery } from '../../utils';
import SipHttp from './sip.service';
import * as Yup from 'yup';
import SipSummary from './SipSummary';
import { ToastContainer, toast } from 'react-toastify';
// import Datetime from 'react-datetime';

const METAL_LABELS = {
  Ag: 'SILVER',
  Au: 'GOLD',
  Pt: 'PLATINUM',
  Pd: 'PALLADIUM',
};

interface PropsType { }

const SipSavingPlan: React.FC<PropsType> = () => {
  const location = useLocation();
  const data = location.state;
  const todayDate = moment().format('YYYY-MM-DD');
  const fiveDaysAhead = moment().add(5, 'days').format('YYYY-MM-DD');
  const twoDaysAhead = moment().add(2, 'days').format('YYYY-MM-DD');


  const [expand, setExpand] = useState(0);
  const [sipPlanName, setSipPlanName] = useState('');
  const [investInterval, setInvestInterval] = useState(data.sipInterval);
  const [metalType, setMetalType] = useState(data.sipMetalType);
  const [sipAmount, setSipAmount] = useState(data.sipAmount);
  const [sipGram, setSipGram] = useState(data.sipGram);
  const [sipType, setSipType] = useState('');
  const [emandates, setEmandates] = useState('withMandateUPI');
  const [sipMethod, setSipMethod] = useState('payemandate');
  const [termCondition, setTermCondition] = useState();
  const [startDate, setStartDate] = useState<any | null>(fiveDaysAhead);
  // const [manualstartDate, setmanualStartDate] = useState<any | null>(todayDate);
  const [emandateList, setEmandateList] = useState([]);
  const [dislaySipSummary, setDislaySipSummary] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedBank, setSelectedBank] = useState('');
  const [isConsented, setIsConsented] = useState(false);
  const [investAmtField, setInvestAmtField] = useState(false);
  const [investGramField, setInvestGramField] = useState(false);
  const [customerId, setUser, user, selectedAccount] = userStore(
    (state: any) => [
      state.customerId,
      state.setUser,
      state.user,
      state.selectedAccount,
    ]
  );
  const [newSIP, setNewSIP] = useState({
    plan_name: '',
    frequency: data.sipInterval,
    installment_amt: data.sipAmount,
    grams: data.sipGram,
    metal: data.sipMetalType,
    duration: '3',
    start_date: startDate,
    bank: '',
    customer_id: customerId,
    is_payment_manual: false,
    isupi: false,
  });

  const [razorpay, setRazorpay] = useState<any>({
    customerId: customerId,
    amount: null,
    paymentMethod: 'NEBK',
  });

  const [dailySipLimits, setDailySipLimits] = useState({
    min: 10,
    max: 2000,
  });


  const isDaily = investInterval === 'daily';
  const minStartDate =
    investInterval === 'daily'
      ? moment().add(2, 'days')
      : moment().add(5, 'days');

  const maxStartDate = moment().add(30, 'days');


  const dateForPicker = (dateString) => {
    return moment(new Date(dateString)).format('YYYY-MM-DD');
  };

  const dateFromDateString = (dateString) => {
    return moment(new Date(dateString)).format('YYYY-MM-DD');
  };

  const getEmandateList = async () => {
    try {
      const query = makeQuery({
        customerId: customerId,
        status: 'CONFIRMED',
        user_id: user?.userId,
      });
      SipHttp.getEmandatesList(query, customerId)
        .then((res: any) => {
          if (res && res.data.data[0]) {
            const objectAsArray: any = Object.values(res?.data?.data[0]);
            setEmandateList(res?.data?.data);
            setEmandates('withoutMandate');
            setNewSIP({
              ...newSIP,
              bank: res?.data?.data[0]?.bank,
            });
            //@ts-ignore
            validation.bank = Yup.string().required('Please enter bank.');
          }
        })
        .catch((err) => {
          console.error('API Error:', err);
        });
    } catch (err) {
      console.log(err);
    }
  };

  const validation = Yup.object().shape({
    // plan_name: Yup.string()
    //   .matches(
    //     /^[A-Za-z0-9\s]+$/,
    //     'Plan name must only contain letters and numbers'
    //   )
    //   .required('Please enter plan name.'),

    bank: Yup.string(),
  });

  async function checkDailySipThreshold() {
    try {
      const res = await SipHttp.checkThreshold({
        partnerId: user?.partner?.id,
      });

      const min = Number(res?.data?.partnerQuotationValue);
      const max = Number(res?.data?.data?.maxSipValue);

      if (min && max) {
        setDailySipLimits({ min, max });
      }
    } catch (err) {
      console.error('Daily SIP threshold error', err);
    }
  }


  useEffect(() => {
    getEmandateList();
    if (data?.sipAmount) {
      setInvestGramField(true);
    } else {
      setInvestAmtField(true);
    }
  }, []);

  const createSIP = async (values) => {

    let finalSIP = { ...newSIP };
    if (!finalSIP.plan_name || finalSIP.plan_name.trim() === '') {
      finalSIP.plan_name = `${finalSIP.frequency.toUpperCase()}_${METAL_LABELS[finalSIP.metal] || finalSIP.metal.toUpperCase()
        }_${String(finalSIP.installment_amt)}`;
    }

    setNewSIP(finalSIP);

    if (emandates === 'withoutMandate' && !newSIP?.bank) {
      return toast.error('Select Bank');
    }

    if (newSIP?.installment_amt == null && newSIP?.grams == null) {
      return toast.error('Please enter investment amount');
    }

    const minAmount =
      newSIP.frequency === 'daily' ? dailySipLimits.min : 100;

    const maxAmount =
      newSIP.frequency === 'daily' ? dailySipLimits.max : 100000;

    if (
      newSIP.installment_amt < minAmount ||
      newSIP.installment_amt > maxAmount
    ) {
      return toast.error(
        `Amount should be between ₹${minAmount} to ₹${maxAmount}`
      );
    }

    const today = moment().startOf('day');

    if (sipMethod === 'paymanual') {
      if (!moment(newSIP.start_date).isSame(today, 'day')) {
        return toast.error(
          `For manual payment, start date must be ${today.format('DD-MM-YYYY')}`
        );
      }
    }

    if (sipMethod === 'payemandate') {
      const minStartDate =
        newSIP.frequency === 'daily'
          ? moment().add(2, 'days').startOf('day')
          : moment().add(5, 'days').startOf('day');

      if (moment(newSIP.start_date).isBefore(minStartDate, 'day')) {
        return toast.error(
          `Start date should be greater than or equal to ${minStartDate.format(
            'DD-MM-YYYY'
          )}`
        );
      }
    }

    setDislaySipSummary(true);
  };


  const onHandleSideModal = (value) => {
    setDislaySipSummary(false);
  };


  const getValidStartDate = () => {
    if (sipMethod === 'paymanual') {
      return moment().format('YYYY-MM-DD');
    }

    return investInterval === 'daily'
      ? moment().add(2, 'days').format('YYYY-MM-DD')
      : moment().add(5, 'days').format('YYYY-MM-DD');
  };


  useEffect(() => {
    if (investInterval === 'daily') {
      checkDailySipThreshold();
    }
  }, [investInterval]);

  useEffect(() => {
    const validDate = getValidStartDate();

    setStartDate(validDate);

    setNewSIP(prev => ({
      ...prev,
      start_date: validDate,
      frequency: investInterval,
      is_payment_manual: sipMethod === 'paymanual',
    }));
  }, [sipMethod, investInterval]);


  return (
    <Layout>
      <div style={{ backgroundColor: 'white' }}>

        <Formik
          initialValues={{
            plan_name: '',
            frequency: data.sipInterval,
            installment_amt: data?.installment_amt,
            grams: data?.sipGram,
            metal: data.sipMetalType,
            duration: '',
            bank: '',
          }}
          onSubmit={(values, { setSubmitting, setErrors }) => {
            setSubmitting(false);
            // save(values, setErrors);

            createSIP(values);
          }}
          validationSchema={validation}
        >
          {({
            values,
            isSubmitting,
            errors,
            touched,
            setErrors,
            setFieldValue,
            setFieldTouched,
            isValid,
            dirty,
          }) => (
            <FormikForm>
              <div className='saving-main-div'>
                <h4>Create new SIP</h4>
                <Card className='plan-card-com '>

                  <Card.Body>
                    <div className='saving-plan-container p-2'>
                      <div>
                        <Form.Group className='mb-3' controlId='orderType'>
                          <Form.Label>SIP plan name</Form.Label>

                          <Field
                            type='text'
                            placeholder=''
                            name='plan_name'
                            className='form-control'
                            onBlur={(e) => {
                              setFieldTouched('plan_name');
                            }}
                            onChange={(e: any) => {
                              setFieldValue('plan_name', e.target.value);
                              setNewSIP({
                                ...newSIP,
                                plan_name: e.target.value,
                              });
                              //   changeAddress(e);
                            }}
                            defaultValue={newSIP?.plan_name}
                          />
                          <div className='error text-danger ml-2'>

                            <ErrorMessage name='plan_name'>
                              {(msg) => <span className='error'>{msg}</span>}
                            </ErrorMessage>
                          </div>

                          <Form.Label className='sip-margin'>
                            Precious Metal Type
                          </Form.Label>
                          <div className='radio-div sip-plan-radio-div'>
                            <Form.Check
                              type='radio'
                              label='Silver'
                              checked={metalType == 'Ag' ? true : false}
                              name='metal'
                              value={'Ag'}
                              onChange={(e) => {
                                setMetalType(e.target.value);
                                setNewSIP({
                                  ...newSIP,
                                  metal: e.target.value,
                                });
                              }}
                              className='custom-radio-button'
                            />
                            <Form.Check
                              type='radio'
                              checked={metalType == 'Au' ? true : false}
                              label='Gold'
                              name='metal'
                              value={'Au'}
                              onChange={(e) => {
                                setMetalType(e.target.value);
                                setNewSIP({
                                  ...newSIP,
                                  metal: e.target.value,
                                });
                              }}
                            />
                            <Form.Check
                              type='radio'
                              checked={metalType == 'Pt' ? true : false}
                              label='Platinum'
                              name='metal'
                              value={'Pt'}
                              onChange={(e) => {
                                setMetalType(e.target.value);
                                setNewSIP({
                                  ...newSIP,
                                  metal: e.target.value,
                                });
                              }}
                            />
                            <Form.Check
                              type='radio'
                              checked={metalType == 'Pd' ? true : false}
                              label='Palladium'
                              name='metal'
                              value={'Pd'}
                              onChange={(e) => {
                                setMetalType(e.target.value);
                                setNewSIP({
                                  ...newSIP,
                                  metal: e.target.value,
                                });
                              }}
                            />
                          </div>

                          <Form.Label className='sip-margin'>
                            Frequency
                          </Form.Label>
                          <div className='radio-div sip-plan-radio-div'>
                            <Form.Check
                              type='radio'
                              label='Daily'
                              checked={
                                investInterval == 'daily' ? true : false
                              }
                              name='payment-group'
                              value={'daily'}
                              onChange={(e) => {
                                setInvestInterval(e.target.value);
                                setNewSIP({
                                  ...newSIP,
                                  frequency: e.target.value,
                                });
                              }}
                            />
                            <Form.Check
                              type='radio'
                              label='Weekly'
                              checked={
                                investInterval == 'weekly' ? true : false
                              }
                              name='payment-group'
                              value={'weekly'}
                              onChange={(e) => {
                                setInvestInterval(e.target.value);
                                setNewSIP({
                                  ...newSIP,
                                  frequency: e.target.value,
                                });
                              }}
                            />
                            <Form.Check
                              type='radio'
                              checked={
                                investInterval == 'monthly' ? true : false
                              }
                              label='Monthly'
                              name='payment-group'
                              value={'monthly'}
                              onChange={(e) => {
                                setInvestInterval(e.target.value);
                                setNewSIP({
                                  ...newSIP,
                                  frequency: e.target.value,
                                });
                              }}
                            />
                          </div>

                          <Form.Label className='sip-margin'>
                            Investment Amount
                          </Form.Label>
                          <CurrencyInput

                            disabled={investAmtField}
                            className=' form-control'
                            name='installment_amt'
                            allowNegativeValue={false}
                            // value={razorpay.amount}
                            onWheel={(e: any) => e.target.blur()}

                            onValueChange={
                              (value, name) => {
                                if (value !== null && Number(value) > 0) {
                                  setSipAmount(value);
                                  setNewSIP({
                                    ...newSIP,
                                    installment_amt: Number(value),
                                  });
                                } else {
                                  setSipAmount(null);
                                  setNewSIP({
                                    ...newSIP,
                                    installment_amt: Number(null),
                                  });
                                }
                              }

                              // onChangeAmount(value, name, true)
                            }
                            value={newSIP?.installment_amt}
                            // prefix='₹ '
                            placeholder='₹ 0'
                            onChange={(e: any) => {
                              setFieldValue('installment_amt', e.target.value);
                              if (e.target.value == '') {
                                console.log('oo', e.target.value);
                                setInvestGramField(false);
                              } else {
                                console.log('ooo', e.target.value);

                                setInvestGramField(true);
                              }
                            }}
                            maxLength={6}
                            decimalsLimit={2}
                          />
                          <div className='error text-danger ml-2'>
                            <ErrorMessage name='installment_amt'>
                              {(msg) => <span className='error'>{msg}</span>}
                            </ErrorMessage>
                          </div>


                          <Form.Label className='sip-margin'>
                            SIP Duration
                          </Form.Label>
                          <Form.Select
                            aria-label='Default select example'
                            name='duration'
                            onChange={(e) => {
                              setSipType(e.target.value);
                              setNewSIP({
                                ...newSIP,
                                duration: e.target.value,
                              });
                            }}
                            value={newSIP?.duration}
                          >
                            <option value='3'>3 months</option>
                            <option value='6'>6 months</option>
                            <option value='9'>9 months</option>
                            <option value='12'>12 months</option>
                            <option value='24'>24 months</option>
                          </Form.Select>

                          <Form.Label className='sip-margin'>
                            Payment Method
                          </Form.Label>
                          <div className='d-flex justify-content-between'>
                            <Form.Check
                              type='radio'
                              label='E-Mandate'
                              name='paymentMethod'
                              value='payemandate'
                              checked={sipMethod === 'payemandate'}
                              onChange={() => {
                                setSipMethod('payemandate');
                                setEmandates('withMandateUPI');
                                setNewSIP({
                                  ...newSIP,
                                  is_payment_manual: false,
                                  isupi: true,
                                });
                              }}
                            />

                            {!isDaily && (
                              <Form.Check
                                type='radio'
                                label='Pay Manually'
                                name='paymentMethod'
                                value='paymanual'
                                checked={sipMethod === 'paymanual'}
                                onChange={() => {
                                  setSipMethod('paymanual');
                                  setEmandates('withMandateUPI');
                                  setNewSIP({
                                    ...newSIP,
                                    is_payment_manual: true,
                                    bank: '',
                                  });
                                }}
                              />
                            )}
                          </div>
                          {sipMethod == 'payemandate' && (
                            <div>
                              {/* <Form.Label className='sip-margin'>
                                E-Mandate
                              </Form.Label> */}

                              <div>
                                <Form.Label
                                  className='sip-margin'
                                  style={{ color: '#DDA838' }}
                                >
                                  Create New E-Mandate
                                </Form.Label>
                                <Form.Check
                                  type='radio'
                                  label='E-Mandate (UPI)'
                                  name='Emandates'
                                  value={'withMandateUPI'}
                                  onChange={(e) => {
                                    setNewSIP({
                                      ...newSIP,
                                      bank: '',
                                      isupi: true,
                                    });
                                    setEmandates(e.target.value);
                                  }}
                                  checked={emandates == 'withMandateUPI'}
                                />
                                {!isDaily && (
                                  <Form.Check
                                    type='radio'
                                    label='E-Mandate (NetBanking/Debit card)'
                                    name='Emandates'
                                    value={'withMandate'}
                                    onChange={(e) => {
                                      setNewSIP({ ...newSIP, bank: '' });
                                      setEmandates(e.target.value);
                                    }}
                                    checked={emandates == 'withMandate'}
                                  />)}
                              </div>
                            </div>
                          )}
                          <Form.Label className='sip-margin'>
                            Start date
                          </Form.Label>

                          <Form.Control
                            type='date'
                            name='start_date'
                            value={dateForPicker(startDate)}
                            disabled={sipMethod === 'paymanual'}
                            onChange={(e) => {
                              const val = dateFromDateString(e.target.value);
                              setStartDate(val);
                              setNewSIP(prev => ({
                                ...prev,
                                start_date: val,
                              }));
                            }}
                            min={
                              sipMethod === 'paymanual'
                                ? todayDate
                                : minStartDate.format('YYYY-MM-DD')
                            }
                            max={
                              sipMethod === 'paymanual'
                                ? todayDate
                                : maxStartDate.format('YYYY-MM-DD')
                            }
                          />

                          <div className='container_checkbox '>
                            <Form.Check
                              className='sip-margin '
                              type='checkbox'
                              label={
                                <>
                                  By creating this SIP, you agree to the{' '}
                                  <a
                                    href='https://ebullion.in/terms-and-conditions/terms.html'
                                    target='_blank'
                                    rel='noopener noreferrer'
                                    style={{
                                      color: '#DDA838',
                                      textDecoration: 'underline',
                                    }}
                                  >
                                    Terms & Conditions
                                  </a>
                                </>
                              }
                              name='payment-group'
                              onClick={() => setIsConsented(!isConsented)}
                            ></Form.Check>
                          </div>
                        </Form.Group>

                        <Button
                          variant='primary'
                          className='btn-block mt-2'
                          type='submit'
                          size='lg'
                          disabled={!isConsented}
                        >
                          Create SIP
                        </Button>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </div>
            </FormikForm>
          )}
        </Formik>
        {/* </div> */}
        <SipSummary
          key={'odrSmrpop'}
          handleModal={onHandleSideModal}
          isShow={dislaySipSummary}
          data={newSIP}
          displaySummary={true}
          emandates={emandates}
          sipMethod={sipMethod}
        />
      </div>
    </Layout>
  );
};

export default SipSavingPlan;
